export default "__VITE_ASSET__JP8SSIFd__"